import { RequestStatusManagerErrorListType } from "utils/hooks/use-request-status-manager.hook";

import AlertToast from "components/generic/alert-toast.component";
import RequestStatusMessage from "components/generic/request-status-message.component";

import {
    defineToastAutoDestroyTime,
    defineToastType,
} from "utils/components/request-status-message-functions";

type ToastRequestHandlerType = {
    allContentIsReady: boolean;
    errorList: RequestStatusManagerErrorListType;
    success?: boolean;
    successMessage?: string;
    errorMessage?: string;
    closeToast: () => void;
};

const ToastRequestHandler = ({
    allContentIsReady,
    errorList,
    success = false,
    successMessage,
    errorMessage,
    closeToast,
}: ToastRequestHandlerType) => {
    const hasError = errorList.length > 0;

    const defineErrorMessage = () => {
        if (errorMessage) return errorMessage;

        if (errorList.length) {
            return errorList[errorList.length - 1].message;
        }

        return undefined;
    };

    return (
        <AlertToast
            isOpen={!allContentIsReady || hasError || success}
            closeToastFn={closeToast}
            autoDestroyAfterMS={defineToastAutoDestroyTime(hasError, success)}
        >
            <RequestStatusMessage
                successMessage={successMessage}
                errorMessage={defineErrorMessage()}
                type={defineToastType(hasError, success)}
            />
        </AlertToast>
    );
};

export default ToastRequestHandler;
